const stringIsNumeric = (num: string) => !Number.isNaN(Number(num));

export default stringIsNumeric;
